/* eslint-disable @typescript-eslint/naming-convention */
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  buttonCancel: {
    width: 72,
    color: `#465869`,
    marginRight: "16px",
  },
  buttonShare: {
    width: 92,
    color: `#FFFFFF`,
    "& div[role=progressbar]": {
      color: `#FFFFFF`,
    },
  },
  modal: {
    width: "730px !important",
  },
  subtitle: {
    fontWeight: 400,
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  shareTypeList: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    listStyle: "none",
    paddingRight: 0,
    "& li": {
      padding: "7px 13px",
      color: `#667085`,
      borderBottom: "2px solid #E4E7EC",
      cursor: "pointer",
      font: "600 14px Manrope",
      "&.active": {
        color: "#0055A4",
        borderBottom: "2px solid #0055A4",
      },
    },
  },
}));

export default styles;
